module.exports = __webpack_public_path__ + "static/img/kh-11.89924dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-11.png
// module id = FSJ+
// module chunks = 5